// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: { id: process.env.GA_ID },
  appName: 'Curate Application',
  pageTrackerScreenviewEnabled: true,
}, router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js